import { Component, Inject, ViewChild, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Column } from '../data-table.interface';
import { MatTable } from '@angular/material/table';

@Component({
  standalone: false,
  selector: 'app-data-table-columns',
  templateUrl: './data-table-columns.component.html',
  styleUrls: ['./data-table-columns.component.scss']
})
export class DataTableColumnsComponent implements OnInit {
  @ViewChild('table') table: MatTable<Column>;
  displayedColumns: string[] = ['visible', 'title', 'name'];
  listColumns: Column[] = [];
  alterCulumn;

  constructor(public dialogRef: MatDialogRef<DataTableColumnsComponent>,
    @Inject(MAT_DIALOG_DATA) public columns: Column[]) {
  }

  ngOnInit() {
    this.listColumns = this.columns.filter(column => column.type !== 'editableColumns');
    this.alterCulumn = this.columns.filter(column => column.type === 'editableColumns')[0];
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  close(): void {
    const columns = [...this.listColumns];
    columns.push(this.alterCulumn);
    this.dialogRef.close(columns);
  }

  dropTable(event: CdkDragDrop<Column[]>) {
    const prevIndex = this.listColumns.findIndex((d) => d === event.item.data);
    moveItemInArray(this.listColumns, prevIndex, event.currentIndex);
    this.table.renderRows();
  }
}
